import { motion } from "framer-motion";

interface AboutProps {
  avatarUrl?: string; // allow external URL
}

export default function About({ avatarUrl }: AboutProps) {
  return (
    <section id="about" className="relative py-24 md:py-36">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="glass-card rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-accent/10 via-accent2/10 to-accent3/10 opacity-40 pointer-events-none" aria-hidden="true" />

          <div className="grid md:grid-cols-[220px_1fr] gap-8 md:gap-12 items-center">
            <div className="relative h-[220px] w-[220px] rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_80px_-20px_rgba(56,189,248,0.5)]">
              {avatarUrl ? (
                <img src={avatarUrl} alt="Portrait of Shota Iasashvili" className="h-full w-full object-cover object-[50%_28%] scale-[1.35]" />
              ) : (
                <img src="/file.svg" alt="Shota avatar" className="h-full w-full object-cover object-[50%_28%] scale-[1.35] dark:invert" />
              )}
            </div>

            <div>
              <h3 className="text-3xl md:text-5xl font-bold mb-4">About</h3>
              <p className="text-lg md:text-xl text-foreground/80 leading-relaxed">
                I’m <span className="font-semibold text-accent">Shota Iasashvili</span> — a web designer and developer focused on crafting
                fast, immersive, and accessible digital experiences. I bring together <Keyword>design</Keyword>, <Keyword>motion</Keyword>,
                and <Keyword>performance</Keyword> to build interfaces that feel alive and effortless.
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                <Badge>Web Design</Badge>
                <Badge>Development</Badge>
                <Badge>Animations</Badge>
                <Badge>SEO</Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Keyword({ children }: { children: React.ReactNode }) {
  return (
    <motion.span
      className="px-1.5 py-0.5 rounded-md bg-white/5 border border-white/10 backdrop-blur-md"
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      {children}
    </motion.span>
  );
}

function Badge({ children }: { children: React.ReactNode }) {
  return (
    <span className="text-xs tracking-wide uppercase px-3 py-1 rounded-full border border-white/10 bg-white/5 text-foreground/70">
      {children}
    </span>
  );
}